export default __webpack_public_path__ + "static/media/live-for-speed.16459e7c.png";